    import React, { useEffect, useState } from 'react';
    import axios from 'axios';
    import { useNavigate } from 'react-router-dom';

    export default function PaymentSuccessfull() {
    const [paymentData, setPaymentData] = useState(null);
    const [bookingData, setBookingData] = useState(null);
    const [boothData, setBoothData] = useState(null);
    const [branchData, setBranchData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Retrieve paymentID from session storage
        const transactionData = sessionStorage.getItem('transactionData');
        if (transactionData) {
        const parsedData = JSON.parse(transactionData);
        const paymentID = parsedData.paymentID;

        if (paymentID) {
            fetchPaymentData(paymentID);
        } else {
            console.error('Payment ID is missing in transaction data');
        }
        } else {
        console.error('No transaction data found in session');
        }
    }, []);

    const fetchPaymentData = async (paymentID) => {
        try {
        // Fetch payment data by paymentID
        const paymentResponse = await axios.get(`https://fboothapi.azurewebsites.net/api/payment/${paymentID}`);
        setPaymentData(paymentResponse.data);

        // Fetch booking data using bookingID from payment data
        if (paymentResponse.data.bookingID) {
            const bookingResponse = await axios.get(`https://fboothapi.azurewebsites.net/api/booking/${paymentResponse.data.bookingID}`);
            setBookingData(bookingResponse.data);

            // Fetch booth data using boothID from booking data
            if (bookingResponse.data.boothID) {
            const boothResponse = await axios.get(`https://fboothapi.azurewebsites.net/api/booth/${bookingResponse.data.boothID}`);
            setBoothData(boothResponse.data);
            console.log(boothResponse.data)

            // Fetch branch data using branchID from booth data
            if (boothResponse.data.branchID) {
                const branchResponse = await axios.get(`https://fboothapi.azurewebsites.net/api/branch/${boothResponse.data.branchID}`);
                setBranchData(branchResponse.data);
            }
            }
        }
        } catch (error) {
        console.error('Error fetching payment, booking, or booth data:', error);
        }
    };

    if (!paymentData) {
        return <div>Loading...</div>;
    }

    // Helper function to format date and time
    const formatDate = (dateTimeString) => {
        const date = new Date(dateTimeString);
        return date.toLocaleDateString([], { year: 'numeric', month: 'long', day: 'numeric' });
    };

    const formatTime = (dateTimeString) => {
        const date = new Date(dateTimeString);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    return (
        <div className="container bg-white flex flex-col justify-center items-center p-24">
        {/* Confirmation Card */}
        <div className="bg-white p-8 rounded-lg shadow-md w-full">
            <div className="flex justify-center mb-8">
            <img src={boothData?.boothPhotos[0]?.boothPhotoUrl || "https://via.placeholder.com/400x300"} alt="Booth" className="rounded-lg w-full h-auto" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">{boothData?.boothName}</h3>

            <div className="border-t border-gray-200 pt-4 mb-4">
            <div className="flex justify-between text-sm text-gray-600">
                <div>
                <p className="font-semibold">Check-in</p>
                <p>{formatDate(bookingData?.startTime)}</p>
                </div>
                <div>
                <p className="font-semibold">Check-out</p>
                <p>{formatDate(bookingData?.endTime)}</p>
                </div>
            </div>
            </div>

            {/* Booking Confirmation */}
            <div className="flex items-center justify-center py-8">
    <div className={`p-4 rounded-full ${paymentData.status === 'Success' ? 'bg-green-100' : 'bg-red-100'}`}>
        {paymentData.status === 'Success' ? (
        <svg
            className="text-green-500 w-10 h-10"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
            ></path>
        </svg>
        ) : (
        <svg
            className="text-red-500 w-10 h-10"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
            ></path>
        </svg>
        )}
    </div>
    <h2 className={`text-xl font-semibold ml-4 ${paymentData.status === 'Success' ? 'text-gray-800' : 'text-red-800'}`}>
        {paymentData.status === 'Success' ? 'Your booking is now confirmed!' : 'Your booking has failed!'}
    </h2>
    </div>


            {/* Trip Details */}
            <div className="border-t border-gray-200 pt-4">
            <p className="text-lg font-semibold text-gray-800 mb-2">Your booking starts {formatDate(bookingData?.startTime)}</p>
            <div className="flex text-gray-600 mb-4">
                <div className="flex items-center mr-8">
                <svg
                    className="w-5 h-5 mr-2 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M8 7V3m8 4V3m-6 8h6m-6 4h6m-9 4h12a2 2 0 002-2V7a2 2 0 00-2-2h-3.5L14 3H10L9.5 5H6a2 2 0 00-2 2v10a2 2 0 002 2z"
                    ></path>
                </svg>
                <p>
                    <span className="font-semibold">Check-in:</span> {formatDate(bookingData?.startTime)}, from {formatTime(bookingData?.startTime)}
                </p>
                </div>
                <div className="flex items-center">
                <svg
                    className="w-5 h-5 mr-2 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M8 7V3m8 4V3m-6 8h6m-6 4h6m-9 4h12a2 2 0 002-2V7a2 2 0 00-2-2h-3.5L14 3H10L9.5 5H6a2 2 0 00-2 2v10a2 2 0 002 2z"
                    ></path>
                </svg>
                <p>
                    <span className="font-semibold">Check-out:</span> {formatDate(bookingData?.endTime)}, until {formatTime(bookingData?.endTime)}
                </p>
                </div>
            </div>

            {/* Contact Details */}
            <div className="text-gray-600 mb-4">
                <p className="mb-2">
                <span className="font-semibold">Branch:</span> {branchData?.branchName}
                </p>
                <p className="mb-2">
                <span className="font-semibold">Address:</span> {branchData?.address}, {branchData?.town}, {branchData?.city}
                </p>
            </div>

            {/* Price Details */}
            <div className="border-t border-gray-200 pt-4">
                <div className="flex justify-between items-center text-gray-800 mb-4">
                <p className="font-semibold text-lg">Total price</p>
                <p className="font-semibold text-lg">{bookingData?.totalPrice.toLocaleString()} VND <span className="text-green-500">{paymentData?.status.toLowerCase()}</span></p>
                </div>
            </div>

            {/* Action Buttons */}
            <div className="flex space-x-4">
        <button 
        className="flex-1 bg-blue-500 text-white py-3 rounded-lg shadow hover:bg-blue-600"
        onClick={() => navigate('/history')}
        >
        View History
        </button>
        <button 
        className="flex-1 border border-blue-500 text-blue-500 py-3 rounded-lg shadow hover:bg-blue-50"
        onClick={() => navigate('/')}
        >
        Homepage
        </button>
    </div>
            </div>
        </div>
        </div>
    );
    }
